<nb-card [style.width]="dialogWidth || null">
    <nb-card-header>{{ title || placeholder }}</nb-card-header>
    <nb-card-body>
      <p *ngIf="description" class="dialog-description">{{ description }}</p>
      <input
        nbInput
        fullWidth
        [placeholder]="placeholder"
        [type]="inputType"
        [(ngModel)]="value"
      />
    </nb-card-body>
    <nb-card-footer>
      <div class="button-group">
        <button nbButton status="basic" (click)="cancel()">Cancel</button>
        <button nbButton status="primary" (click)="submit()">OK</button>
      </div>
    </nb-card-footer>
  </nb-card>
